export default __webpack_public_path__ + "static/media/mu-dropicon.86d5638d.svg";